import { Maximize2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Sheet, SheetContent, SheetDescription, SheetTitle } from '@/components/ui/sheet';
import { BuildDetalheView } from './BuildDetalheView';

/**
 * Detalhe da versão como painel lateral, aberto a partir do feed e da fila de
 * homologação sem perder a posição da lista. A versão aberta vive na URL
 * (`?versao=`) de quem monta o Sheet, então o link é compartilhável e o
 * "voltar" do navegador fecha o painel.
 */
export function VersaoSheet({ versao, aoFechar }: { versao: string | null; aoFechar: () => void }) {
  return (
    <Sheet open={versao !== null} onOpenChange={(aberto) => !aberto && aoFechar()}>
      <SheetContent side="right" className="w-[min(60rem,100vw)] gap-0 p-0 sm:w-[min(60rem,calc(100vw-3rem))]">
        <div className="flex items-center gap-2 border-b border-border px-6 py-3 pr-14">
          <SheetDescription className="flex-1 text-cell">Detalhe da versão</SheetDescription>
          {versao ? (
            <Link
              to={`/versoes/${encodeURIComponent(versao)}`}
              className="inline-flex items-center gap-1.5 rounded-button px-2 py-1 text-label text-primary transition-colors duration-fast ease-standard hover:bg-primary-wash"
            >
              <Maximize2 className="size-3.5" aria-hidden="true" />
              Abrir em página
            </Link>
          ) : null}
        </div>
        <div className="px-6 py-6">
          {versao ? (
            <BuildDetalheView
              versao={versao}
              titulo={(texto, className) => (
                <SheetTitle className={`${className} pr-0`}>{texto}</SheetTitle>
              )}
            />
          ) : null}
        </div>
      </SheetContent>
    </Sheet>
  );
}
